/**
 * AUTH_DEBUG: dev-only auth/billing diagnostics.
 * Grep for AUTH_DEBUG or authDebugLog to remove after production confirms the billing return fix.
 */
export function authDebugLog(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log('[auth-debug]', ...args);
  }
}
